import FetchData from '@shared/utils/fetchData/fetchData';

export const receiptOrder = async (number: string) => {
  return await FetchData.get<{ url: string }>(`orders/receipt/${number}`, {});
};
